import ModelEntity from "../../../model2/model-entity"
import WorkWeekSchedule from "../../../model2/work-week-schedule/work-week-schedule"
import {EntityType} from "../../../gd/const/item"

export default class CompanySettingsWorkSchedule extends ModelEntity {

    private _workWeekSchedule?  : WorkWeekSchedule

    public workWeek             : number[]
    public workdayDuration      : number
    public weekStart            : 'mon' | 'tue' | 'wed' | 'thu' | 'fri' | 'sat' | 'sun'
    public workdayDurations     : number[]

    constructor(data: any) {
        super('companySettingsWorkSchedule')

        this.workWeek            = _.get(data, 'workWeek', [1,1,1,1,1,0,0])
        this.workdayDuration     = _.get(data, 'workdayDuration', 480)
        this.weekStart           = _.get(data, 'weekStart', 'mon')
        this.workdayDurations    = _.get(data, 'workdayDurations', [480,480,480,480,480,0,0])

        // init width values from previous settings version
        if (!data?.workdayDurations) {
            this.workdayDurations = _.map(this.workWeek, value=>value * this.workdayDuration)
        }
    }

    get workWeekSchedule(): WorkWeekSchedule {
        if (!this._workWeekSchedule) {
            this._workWeekSchedule = new WorkWeekSchedule(
                EntityType.COMPANY,
                this.workdayDurations[0],
                this.workdayDurations[1],
                this.workdayDurations[2],
                this.workdayDurations[3],
                this.workdayDurations[4],
                this.workdayDurations[5],
                this.workdayDurations[6],
            )
        }

        return this._workWeekSchedule
    }

    resetWorkWeekSchedule() {
        this._workWeekSchedule = undefined
    }

    reset() {
        this.workWeekSchedule.reset()
        this.weekStart = 'mon'
    }

    toJSON() {
        if (this._workWeekSchedule) {
            this.workdayDurations = this._workWeekSchedule.toArray()
        }

        return {
            workWeek            : this.workWeek,
            workdayDuration     : this.workdayDuration,
            weekStart           : this.weekStart,
            workdayDurations    : this.workdayDurations,
        }
    }
}